import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "21",
  fill: "none",
  viewBox: "0 0 23 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "M16.081 0c-.98 0-1.945.24-2.814.7a6.1 6.1 0 0 0-2.177 1.944A6.1 6.1 0 0 0 8.913.701 6 6 0 0 0 6.1 0C4.482 0 2.93.654 1.787 1.817A6.26 6.26 0 0 0 0 6.205c0 6.453 7.209 11.776 11.09 14.497 3.882-2.721 11.09-8.044 11.09-14.497a6.3 6.3 0 0 0-.463-2.375 6.2 6.2 0 0 0-1.323-2.013A6.1 6.1 0 0 0 18.415.472 6 6 0 0 0 16.081 0"
    }, null, -1)
  ])))
}
export default { render: render }